<template>
  <v-main class="bg-background" scrollable>
    <div class="ma-4" data-testid="so-page">
      <slot></slot>
    </div>
  </v-main>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  export default defineComponent({})
</script>
